document.addEventListener("DOMContentLoaded", function () {

    const modal = document.getElementById("walkine-modal");
    const openBtn = document.getElementById("walkine-open");
    const closeBtn = document.querySelector(".walkine-close");
    const overlay = document.querySelector(".walkine-overlay");

    const letterGrid = document.getElementById("walkine-letter-grid");
    const colourButtons = document.querySelectorAll(".walkine-colour");
    const collarButtons = document.querySelectorAll(".walkine-collar");

    const selectedContainer = document.getElementById("walkine-selected");
    const previewContainer = document.getElementById("walkine-preview-letters");
    
    const previewBar = document.getElementById("walkine-preview-bar");
    const clearButton = document.getElementById("walkine-clear");
    const saveButton = document.getElementById("walkine-save");
    const savedList = document.getElementById("walkine-saved-list");
    


    console.log(saveButton);


const collarColours = {

    Strawberry:"#F6B5C7",

    Vanilla:"#FFF0C7",

    "Sea Salt":"#DDF5FF",

    "Green Tea":"#D5ECC1",

    Taro:"#D8C6F3"

};
    previewContainer.addEventListener("click", function(e){
        

    const removeBtn = e.target.closest(".walkine-remove-preview");

    if(!removeBtn) return;

    e.stopPropagation();

    const index = Number(removeBtn.dataset.index);

    selected.splice(index,1);

hasUnsavedChanges = true;

refresh();

});



    const totalLetters = document.getElementById("walkine-letter-total");
    const totalPrice = document.getElementById("walkine-total-price");

    
    const PRICE_PER_CHARM = 7;
    const CHARM_SPACING = 60;
    let charmSpacing = CHARM_SPACING;

    if (window.innerWidth <= 768) {
        charmSpacing = 42;
    }

    let currentColour = "Strawberry";

    let selected = [];
    let savedPersonalizations = [];
    let hasUnsavedChanges = false;
    

const colours = {
    "Strawberry":"#F8A8BC",
    "Vanilla":"#F9EFB5",
    "Sea Salt":"#BFEAF7",
    "Green Tea":"#D5ECC1",
    "Taro":"#CFA7E8"
};
const FILE_BASE =
"https://cdn.shopify.com/s/files/1/0681/4236/7003/files/";

const CHARM_IMAGES = {};

const COLOUR_FILES = {
    "Strawberry": "strawberry",
    "Vanilla": "vanilla",
    "Sea Salt": "seasalt",
    "Green Tea": "greentea"
};

const VERSION = "1785000000";

"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").forEach(letter => {

    Object.entries(COLOUR_FILES).forEach(([colour, file]) => {

        CHARM_IMAGES[`${colour}-${letter}`] =
            `${file}-${letter.toLowerCase()}.png?v=${VERSION}`;

    });

});

    /*--------------------
      OPEN / CLOSE
    --------------------*/

   openBtn.addEventListener("click", () => {

    modal.classList.add("active");

    refresh();

});

    function closeModal() {
        modal.classList.remove("active");
    }

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", function(e){

    if(e.target === modal){

        closeModal();

    }

});

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeModal();
        }
    });

    /*--------------------
      COLOUR
    --------------------*/

  colourButtons.forEach(button => {

    button.addEventListener("click", function () {

        colourButtons.forEach(b => b.classList.remove("active"));

        this.classList.add("active");

        currentColour = this.dataset.colour;

hasUnsavedChanges = true;

buildLetterGrid();

refresh();

    });

});
collarButtons.forEach(button => {

    button.addEventListener("click", function(){

        collarButtons.forEach(b => b.classList.remove("active"));

        this.classList.add("active");

        previewBar.style.background = this.style.background;

hasUnsavedChanges = true;

        

    

});

});

    /*--------------------
  BUILD LETTER GRID
--------------------*/

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

buildLetterGrid();

function buildLetterGrid() {

    letterGrid.innerHTML = "";

    letters.forEach(letter => {

        const button = document.createElement("button");

        button.type = "button";

        button.className = "walkine-letter";

        button.dataset.letter = letter;

        const fileColour = currentColour
    .toLowerCase()
    .replace(/\s/g,"");

button.innerHTML = `

<img
class="walkine-gallery-image"
src="${FILE_BASE}${fileColour}-${letter.toLowerCase()}.png?v=1784452045"
alt="${letter}">

`;

        button.addEventListener("click", function () {

            if (selected.length >= 10) {

            return;

            }


            selected.push({

            letter: letter,

            colour: currentColour

            });

hasUnsavedChanges = true;

refresh();

        });

        letterGrid.appendChild(button);

    });

}
/*--------------------
  CLEAR BUTTON
--------------------*/

if (clearButton) {

    clearButton.addEventListener("click", function () {

        selected = [];

hasUnsavedChanges = true;

refresh();

    });

}
    /*--------------------
      REFRESH UI
    --------------------*/

    function refresh() {

        selectedContainer.innerHTML = "";

        previewContainer.innerHTML = "";
        

        

        if (selected.length === 0) {

            selectedContainer.innerHTML =

                "<p class='walkine-empty'>No charms selected</p>";

        } else {

            selected.forEach((item, index) => {

                /* Selected List */

                const row = document.createElement("div");

                row.className = "walkine-item";

                row.innerHTML = `
                    <div class="walkine-left">

                        <span class="walkine-dot"
                              style="background:${colours[item.colour]}">
                        </span>

                        <strong>${item.letter}</strong>

                        <small>${item.colour}</small>

                    </div>

                    <button
                        class="walkine-remove"
                        data-index="${index}">
                        ×
                    </button>
                `;

                selectedContainer.appendChild(row);

                

                /* Preview */

/* Preview */

const previewLetter = document.createElement("div");

previewLetter.className = "walkine-preview-letter";

const totalWidth =
    (selected.length - 1) * charmSpacing;

const startX =
    -totalWidth / 2;

previewLetter.style.left =
`${startX + (index * charmSpacing)}px`;

previewLetter.dataset.index = index;



const key = `${item.colour}-${item.letter}`;
const image = CHARM_IMAGES[key];


if (image) {

    previewLetter.innerHTML = `

        <span
            class="walkine-remove-preview"
            data-index="${index}">

            ×

        </span>

        <img
            class="walkine-preview-image"
            src="${FILE_BASE}${image}">

    `;

} else {

    previewLetter.innerHTML = `

        <span
            class="walkine-remove-preview"
            data-index="${index}">

            ×

        </span>

        <span class="walkine-letter-text">

            ${item.letter}

        </span>

    `;

}

previewContainer.appendChild(previewLetter);




            });

        }

        


        /* Remove */

        document.querySelectorAll(".walkine-remove").forEach(button => {

            button.addEventListener("click", function () {

                selected.splice(this.dataset.index, 1);

hasUnsavedChanges = true;

refresh();

            });

        });


              /* Price */

        totalLetters.textContent = selected.length;
        totalPrice.textContent = selected.length * PRICE_PER_CHARM;
        document.getElementById("walkine-preview-count").textContent = selected.length;

    } // <-- end refresh()

function getTotalCharmCount(){

    return savedPersonalizations.reduce(function(total,set){

        return total + set.charmCount;

    },0);

}

function buildCharmProperties(){

    let properties = {};

    const colourNames = {
        "Strawberry": "Pink",
        "Vanilla": "Yellow",
        "Sea Salt": "Blue",
        "Green Tea": "Green"
    };

    savedPersonalizations.forEach(function(set, index){

        let value = "Pet Name: " + set.petName + "\n\n";

        set.charms.forEach(function(charm){

            const displayColour = colourNames[charm.colour] || charm.colour;

            value += "[" + displayColour + " " + charm.letter + "] ";

        });

        properties["Set " + (index + 1)] = value;

    });

    return properties;

}
    
function renderSavedList(){

    savedList.innerHTML = "";

    savedPersonalizations.forEach((set,index)=>{

        const card = document.createElement("div");

        card.className = "walkine-saved-card";

        const letters = set.charms.map(charm=>{

            const colour = charm.colour
                .toLowerCase()
                .replace(/\s/g,"");

            return `
                <img
                    class="walkine-saved-image"
                    src="${FILE_BASE}${colour}-${charm.letter.toLowerCase()}.png?v=1785000000">
            `;

        }).join("");

        card.innerHTML = `

            <div class="walkine-saved-left">

                ${letters}

            </div>

            <div class="walkine-saved-middle">

                <strong>

                    Charms — ${set.charmCount} ${set.charmCount>1?"charms":"charm"}

                </strong>

                <div>

                    RM${PRICE_PER_CHARM} × ${set.charmCount} = RM${PRICE_PER_CHARM*set.charmCount}

                </div>

            </div>

            <button
                class="walkine-delete-set"
                data-index="${index}">

                Delete

            </button>

        `;

        savedList.appendChild(card);
        card.querySelector(".walkine-delete-set").addEventListener("click", function(){

    savedPersonalizations.splice(index, 1);
            


    renderSavedList();

});

    });
    if(savedPersonalizations.length > 0){

    openBtn.textContent = "Add Another Set of Charms";

}else{

    openBtn.textContent = "Personalize with Charms";

}

}

saveButton.addEventListener("click", function(){

    if (selected.length === 0) {
        closeModal();
        return;
    }

    savedPersonalizations.push({

        charms: JSON.parse(JSON.stringify(selected)),

        collarColour: document.querySelector(".walkine-collar.active").dataset.collar,

        charmCount: selected.length,

        petName: selected.map(c => c.letter).join("")

    });
    console.log(savedPersonalizations);

    hasUnsavedChanges = false;



    renderSavedList();
    console.log(buildCharmProperties());
    selected = [];

    refresh();

    closeModal();

});
let lastCartCount = 0;

async function getCartCount(){

    const cart = await fetch("/cart.js").then(r=>r.json());

    return cart.item_count;

}

getCartCount().then(count=>{

    lastCartCount = count;

    console.log("Initial cart:",count);

});

let addingCharm = false;

async function addCharmProduct() {
     console.trace("addCharmProduct called");
    
    const properties = buildCharmProperties();

    // Don't add a charm if nothing has been saved.
    if (Object.keys(properties).length === 0) {
        console.log("No saved charms. Skipping addCharmProduct().");
        return;
    }

        // 👇 ADD THIS
    const body = {
        items: [
            {
                id: 52579430990107,
                quantity: getTotalCharmCount(),
                properties: properties
            }
        ]
    };

    console.log("REQUEST BODY:");
    console.log(body);
    console.log(JSON.stringify(body, null, 2));

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            items: [
                {
                    id: 52579430990107,
                    quantity: getTotalCharmCount(),
                    properties: properties
                }
            ]
        })
    });

}

document.addEventListener("walkine:collar-added", async function () {

    // No personalization saved → do nothing.
    if (savedPersonalizations.length === 0) {
        return;
    }

    console.log("Adding charm...");
    await addCharmProduct();

});

}); // <-- end DOMContentLoaded
    



/*
KNOWN ISSUE (2026-07-18)

Very specific combination:

A - Strawberry
B - Vanilla
C - Sea Salt
D - Green Tea

can trigger a fallback form submission.

All other tested combinations work.

If this ever becomes a customer issue,
revisit the personalization serialization
and Dawn form submission flow.

DO NOT remove the setTimeout() in product-form.js.
*/